export class SaveInformationPostModel {
    public email: string;
    public firstname: string;
    public lastname: string;
    public kennelname: string;
  }
  